import { useSyncExternalStore } from 'react';
import {
  getProgress,
  getProgressVersion,
  getSettings,
  getSettingsVersion,
  type Progress,
  type Settings,
  subscribeProgress,
  subscribeSettings,
} from './state';

/** Current settings; re-renders when any setting changes. */
export function useSettings(): Settings {
  useSyncExternalStore(subscribeSettings, getSettingsVersion);
  return getSettings();
}

/** Current progress; re-renders on every progress update (XP, badges, levels, records). */
export function useProgress(): Progress {
  useSyncExternalStore(subscribeProgress, getProgressVersion);
  return getProgress();
}
